import React from 'react';
import Button from "./Button";

const BtnLinkCenter = ({value="Contacter nos experts", link="/contact", className}) => {
    return (
        <div className="btn-center">
            <Button value={value}
                    link={link}
                    className={className + " big-button"}/>
        </div>
    )
};


export default BtnLinkCenter;